import { ref, computed } from 'vue';

export const loadingCount = ref(0);
export const isLoading = computed(() => loadingCount.value > 0);
